// project imports
import * as actionTypes from "./actions";

export const initialState = [
  { name: "google", selected: false },
  { name: "bing-Aerial-labels", selected: false },
  { name: "openStreetMap", selected: false },
  { name: "mapbox", selected: true },
];

const dataLayersReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_BASEMAP:
      return state.map((item) => ({
        ...item,
        selected: action.value.name === item.name,
      }));
    default:
      return state;
  }
};

export default dataLayersReducer;
